<template>
  <CrudList
    title="Términos y condiciones"
    storeName="Terms"
    labelAddNew="Agregar nuevo ítem"
    slot-scope="{ item }"
    sortable
    canSearch
  >
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
